// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","278":"polyfills-dom","329":"polyfills-core-js","777":"recorder"}[chunkId] || chunkId) + ".js";
};